<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="account">

      <div class="content access_ctrl">
        <!-- region 顶部操作栏 -->
        <div class="top-bar">
          <div class="left">
            <button-add @click="handleAdd()" v-if="permissionCodes.indexOf('009002001') !== -1"/>
            <button-delete @click="remove(selected)" v-if="permissionCodes.indexOf('009002002') !== -1"/>
          </div>
          <input-search class="search" @search="search" placeholder="电梯名称" />
        </div>
        <el-table class="width-full" :data="posDevices" :height="618"
                  header-row-class-name="app-center-table-header"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column label="电梯名称">
            <template slot-scope="scope">
              <span :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="楼栋名称">
            <template slot-scope="scope">
              <span :title="scope.row.buildingName">{{scope.row.buildingName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="通行属性" >
            <template slot-scope="scope">
              <span :title="scope.row.passAttributeText">{{scope.row.passAttributeText}}</span>
            </template>
          </el-table-column>
          <el-table-column label="关联设备" >
            <template slot-scope="scope">
              <span :title="scope.row.relateGatewayName">{{scope.row.relateGatewayName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="场景" >
            <template slot-scope="scope">
              <span title="园区场景" v-if="scope.row.scene === '1'">园区场景</span>
              <span title="楼栋场景" v-if="scope.row.scene === '2'">楼栋场景</span>
            </template>
          </el-table-column>
          <el-table-column label="起始楼层" >
            <template slot-scope="scope">
              <span :title="scope.row.startLevel">{{scope.row.startLevel}}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束楼层" >
            <template slot-scope="scope">
              <span :title="scope.row.endLevel">{{scope.row.endLevel}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <a @click="toModifyPage(scope.row.code)">修改</a>
              <a @click="toShowCode(scope.row)">乘梯码</a>
              <a @click="remove(scope.row.code)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- endregion 表格 -->
        <div class="ladder-page">
          <el-pagination background layout="total, prev, pager, next, jumper"
                         @current-change="onPageChanged" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="乘梯码" :visible.sync="codeVisible" width="600px">
      <el-form style="width: 400px;margin: 0 auto;">
        <div style="display:flex;justify-content:flex-start;align-items:center;">
          <div style="width:100px;margin-right:20px;">请选择楼层</div>
          <el-select v-model="currentFloor" size="small" style="width: 180px">
            <el-option v-for="item in floorList" :key="item.value"
                      :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <button-confirm value="生成二维码" @confirm="getCodes()" style="margin-left:20px;" />
        </div>
      </el-form>
      <canvas class="floorCode" ref="floorCodeUrl" id="floorCode" v-loading="loading"></canvas>
      <div style="height: 50px;line-height: 30px;margin:10px auto;text-align:center;">{{currentElevatorAndFloor}}</div>
      <el-select v-model="chargeSize" size="mini" style="width: 170px;margin: 10px auto;display: block;">
        <el-option v-for="item in sizeList" :key="item.value"
                    :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-dialog>
  </div>
</template>

<script>
import QrCodeWithLogo from "qr-code-with-logo";
import api from "../../api/LadderControl";
import { nAlert, nSuccess, nTipFunc, nWarn } from "../../../utils/notice";
import InputSearch from "../../../components/common/inputs/input-search";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonDelete from "../../../components/common/buttons/button-delete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { bus } from "../../../utils/bus";

export default {
  name: "elevator",
  components: {
    Breadcrumb,
    ButtonConfirm,
    BreadCrumb,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    InputSearch
  },
  data() {
    return {
      deviceOptions: [
        {
          id: "",
          label: "全部"
        },
        {
          id: "0",
          label: "离线"
        },
        {
          id: "1",
          label: "在线"
        }
      ],
      config: {
        breadcrumb: [
          {
            value: "智慧梯控",
            name: "ladder-device"
          },
          {
            value: "电梯管理"
          }
        ]
      },
      exportUrl: api.accessDeviceInfoDownloadUrl(),
      uploadUrl: api.accessDeviceInfoUploadUrl(),
      filterText: "",
      posDevices: [],
      total: 0,
      requestBody: {
        pageNum: "1",
        pageSize: "10",
        searchKey: "",
        deviceStatus: "",
        deviceType: ""
      },
      id: "1",
      selected: "",
      permissionCodes: "",
      codeVisible: false,
      currentElevatorName: "",
      currentElevatorCode: "",
      currentElevatorAndFloor: "",
      currentFloor: "",
      chargeSize: 300,
      sizeList: [
        {
          value: 300,
          label: "300*300"
        },
        {
          value: 500,
          label: "500*500"
        },
        {
          value: 1000,
          label: "1000*1000"
        }
      ],
      loading: false,
      floorList: [],
      floorCodeName: "",
      showChangeSize: false
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.render();
  },
  activated() {
    this.render();
  },
  watch: {
    $route() {
      this.render();
    }
  },
  methods: {
    /**
     * 多选框选择事件
     */
    handleSelectionChange(selectedIds) {
      console.log(selectedIds);
      let deviceCodeArr = [];
      selectedIds.map(v => {
        deviceCodeArr.push(v.deviceCode);
      });
      this.selected = deviceCodeArr.join(",");
    },

    /**
     * 移除
     */
    remove(codes) {
      if (codes.length === 0) {
        nWarn("请先选择需要删除的设备");
        return;
      }
      this.$confirm("确认删除？").then(
        () => {
          api
            .deleteLiftDevice({ codes: codes })
            .then(nTipFunc("删除成功"))
            .then(this.render);
        },
        () => {
          console.debug("用户取消了删除");
        }
      );
    },

    render() {
      this.renderPosDevices();
    },

    renderPosDevices() {
      api.getLiftDevice(this.requestBody).then(data => {
        this.total = data.total;
        let list = data.list;
        list.map(v => {
          if (v.passAttribute === 0) {
            v.passAttributeText = "单双层";
          } else if (v.passAttribute === 1) {
            v.passAttributeText = "单层";
          } else if (v.passAttribute === 2) {
            v.passAttributeText = "双层";
          }
        });
        this.posDevices = list;
      });
    },

    onPageChanged(page) {
      this.requestBody.pageNum = page + "";
      this.renderPosDevices();
    },

    search(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.searchKey = val;
      this.renderPosDevices();
    },

    handleSelect(val) {
      this.requestBody.deviceStatus = val;
      this.renderPosDevices();
    },

    deviceTypeSelect(val) {
      this.requestBody.deviceType = val;
      this.renderPosDevices();
    },

    handleAdd() {
      this.$router.push({
        path: "/elevator_add"
      });
    },

    toModifyPage(code) {
      this.$router.push({
        path: "/elevator_modify/" + code
      });
    },

    onUploadSuccess(data) {
      const e = errorHandler("导入失败")(data);
      if (!(e instanceof Error)) {
        nSuccess("导入成功");
        this.render();
      }
    },

    toShowCode(data) {
      this.codeVisible = true;
      this.getFloorList(data);
    },

    getFloorList(data) {
      this.currentElevatorName = data.name;
      this.currentElevatorCode = data.code;
      let floorList = [];
      if (data.passAttribute == 1) {
        // 单层
        for (let i = data.startLevel; i < data.endLevel; i++) {
          if (i % 2 != 0 && i != 0) {
            let obj = {
              value: i,
              label: `${i}层`
            };
            floorList.push(obj);
          }
        }
      } else if (data.passAttribute == 2) {
        // 双层
        for (let i = data.startLevel; i < data.endLevel; i++) {
          if (i % 2 == 0 && i != 0) {
            let obj = {
              value: i,
              label: `${i}层`
            };
            floorList.push(obj);
          }
        }
      } else if (data.passAttribute == 0) {
        // 单双层
        for (let i = data.startLevel; i < data.endLevel; i++) {
          if (i != 0) {
            let obj = {
              value: i,
              label: `${i}层`
            };
            floorList.push(obj);
          }
        }
      }
      this.floorList = floorList;
    },

    // 获取二维码
    getCodes() {
      this.loading = true;
      let content = `https://yq.damaiiot.com/yq/smallProgram/ladderControl/?yqCode=${
        bus.global.yqCode
      }&elevator=${this.currentElevatorCode}&floor=${this.currentFloor}`;
      this.showChangeSize = true;
      this.currentElevatorAndFloor = `${this.currentElevatorName}${
        this.currentFloor
      }层`;
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById("floorCode"),
          content: content,
          width: this.chargeSize
        }).catch();
        this.loading = false;
      }, 100);
    }
  },
  watch: {
    chargeSize() {
      this.getCodes();
    },
    codeVisible() {
      if (this.codeVisible === false) {
        this.showChangeSize = false;
      }
    }
  }
};
</script>

<style scoped>
.floorCode {
  display: block;
  width: 200px !important;
  height: 200px !important;
  margin: 20px auto 10px;
  position: relative;
}
.account {
  display: flex;
  justify-content: space-between;
}

.school {
  width: 22%;
  float: left;
  padding: 20px 10px 0 0;
  border-right: 1px solid #e6ebf2;
}

.yq_name li {
  width: 100px;
}

.content {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  position: relative;
}

.statues {
  display: inline-block;
  line-height: 32px;
  margin-right: 10px;
}

.select-box select {
  width: 60%;
  height: 24px;
  margin-left: 5px;
  border: 1px solid #d7d7d7;
}

.info ul {
  height: 42px;
  color: #48576a;
  font-weight: 400;
  background-color: #eff1f5;
  line-height: 40px;
  margin-top: 5px;
}

.ladder-page {
  margin: 20px auto 0;
}
.width-full a {
  color: #00a0e6;
}
.width-full a:hover {
  color: #06b3ff;
}
</style>

<style lang="less">
.top-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin: 0 10px 15px 15px;
  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search {
    width: 240px;
  }
  .export {
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #ffffff;
    border-radius: 5px;
    float: left;
    font-size: 14px;
    margin-right: 2%;
    text-align: center;
    font-weight: 400;
    color: #48576a;
    border: 1px solid #d7d7d7;
    background-color: #f7f7f7;
    &:hover {
      color: #00a0e6 !important;
      border: 1px solid #00a0e6 !important;
    }
  }
}
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #f0f7ff;
}

.app-center-table-header th {
  background-color: #eff1f5 !important;
  color: #48576a;
  .cell {
    text-align: center;
  }
}
.el-table .cell {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/Elevator/Elevator.vue